import { memoCoursesType, categoryType } from "@/interFace/courses/types";
import Link from "next/link";
import Image from "next/image";
import AuthorImg from "../../../../public/assets/img/course/Abstract-Author (Resized64X64).jpeg";
import CourseImg from "../../../../public/assets/img/course/Abstract-Course (Resized).jpeg";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Translations } from "@/translations";
import { getLink, Routes } from "@/constants";
import { useTranslations } from "next-intl";
import { useIsMobile } from "@/hooks/useIsMobile";
import { GetCurrencySymbol, GetPrice } from "@/lib/Pricing";
import parse from "html-react-parser";
import { useSearchParams } from "next/navigation";

interface MainProps {
    locale: string;
    data: memoCoursesType[];
}

const PaginationList: React.FC<MainProps> = ({ locale, data}) => {
  const t = useTranslations('Courses');
  const mobile = useIsMobile(768);
  const searchParams = useSearchParams();
  const querySuffix = searchParams.toString() ? `?${searchParams.toString()}` : "";
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="list"
        role="tabpanel"
        aria-labelledby="list-tab"
        style={{ minHeight: "300px" }}
      >
        {/* 274 */}
        <div className="row gx-0 h-100 align-items-stretch">
          {data.map((item, index) => (
            <div key={index} className="col-xxl-12">
              {(() => {
                const price = GetPrice(item.prices);
                const isUnavailable = item.isPurchasable === false;

                return (
              <div
                className="course__item fix"
                style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
              >
                <div className="row gx-0 align-items-stretch h-100">
                  <div className="col-xxl-4 col-xl-4 col-lg-4 h-100">
                    <div className="course__thumb course__thumb-list w-img p-relative fix">
                      <Link
                        href={`${getLink(locale, Routes.QUIZ_DETAILS, item.id)}${querySuffix}`}
                        className="d-flex"
                      >
                        <div className="course__image-wrapper">
                          <Image
                            src={item.image ? item.image : CourseImg}
                            className="img-fluid course__image"
                            alt={item.title}
                          />
                        </div>
                      </Link>
                      <div className="course__tag">
                        <Link
                          href={`${getLink(locale, Routes.QUIZ_DETAILS, item.id)}${querySuffix}`}
                          className="sky-blue"
                        >
                          {item?.categories?.map(
                            (catItem: categoryType, index) => {
                              return (
                                <span key={index}>
                                  {index > 0 ? " & " : ""}
                                  {catItem.title}
                                </span>
                              );
                            }
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* course right */}
                  <div className="col-xxl-8 col-xl-8 col-lg-8 d-flex flex-grow-1">
                    <div className="course__content-wrapper d-flex flex-column justify-content-between">
                      {/* course content */}
                      <div className="course__content course__content-3 course__content-3--compact">
                        <div className="course__content-head">
                          {/* chapter numbers */}
                          <div className="course__meta d-flex align-items-center">
                            <div className="course__lesson">
                              <span>
                                <i className="far fa-book-alt"></i>
                                <span>{item.totalChapters + " "}</span>
                                <span>{t(Translations.Courses.Chapters)}</span>
                              </span>
                            </div>
                          </div>
                          {/* Title */}
                          <h3 className="course__title-3">
                            <Link
                              href={`${getLink(
                                locale,
                                Routes.QUIZ_DETAILS,
                                item.id
                              )}${querySuffix}`}
                            >
                              {item.title}
                            </Link>
                          </h3>
                        </div>
                        {/* Description */}
                        {!mobile && (
                          <div className="course__description-preview">
                              {parse(item.description ? item.description.substring(0, 300) : "")}
                              {item.description && item.description.length > 300 && (
                                <Link
                                  href={`${getLink(locale, Routes.QUIZ_DETAILS, item.id)}${querySuffix}`}
                                  className="read-more"
                                >
                                  ...
                                </Link>
                              )}
                          </div>
                        )}
                        {/* Image author and link memocipe */}
                        {!mobile && item.authors.length > 0 && (
                          <div className="course__teacher course__teacher--compact d-flex align-items-center pb-15">
                            <div className="course__teacher-thumb mr-15 square-wrapper">
                              <Image
                                src={
                                  item.authors?.[0]?.tutorImg
                                    ? item.authors[0].tutorImg
                                    : AuthorImg
                                }
                                className="img-fluid"
                                alt="image not found"
                              />
                            </div>
                            <h6>
                              <Link href="#">{item.authors?.[0]?.name}</Link>
                            </h6>
                          </div>
                        )}
                      </div>
                      {/* course more */}
                      <div className="course__more course__more-2 d-flex justify-content-between align-items-center">
                        {isUnavailable ? (
                          <div className="course__status">
                            <span className="course__video-discount">
                              <span className="course__free">
                                {item.unavailableReason ?? "Not available"}
                              </span>
                            </span>
                          </div>
                        ) : item.prices ? (
                          <div className="course__status">
                            <span
                              className={
                                price.price === 0
                                  ? "course__video-discount"
                                  : "sky-blue"
                              }
                            >
                              {price.price === 0 ? (
                                <span className="course__free">
                                  {t(Translations.Courses.Free)}
                                </span>
                              ) : (
                                `${price.currencySymbol} ${price.price}`
                              )}
                            </span>
                            <span className="old-price">
                              {price.oldPrice === 0
                                ? " "
                                : `${price.currencySymbol} ${price.oldPrice}`}
                            </span>
                          </div>
                        ) : (
                          <span className="course__free">
                            {t(Translations.Courses.Free)}
                          </span>
                        )}
                        <div className="course__btn">
                          <Link
                            href={`${getLink(
                              locale,
                              Routes.QUIZ_DETAILS,
                              item.id
                            )}${querySuffix}`}
                            className="link-btn"
                          >
                            {t(Translations.Courses.KnowDetails)}
                            <i className="far fa-arrow-right"></i>
                            <i className="far fa-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                );
              })()}
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .course__description-preview {
          margin-top: 8px;
        }

        .course__content-3--compact {
          justify-content: flex-start;
          gap: 10px;
        }

        .course__content-head {
          margin-bottom: 0;
        }

        .course__content-head :global(.course__meta) {
          margin-bottom: 4px;
        }

        .course__content-head :global(.course__title-3) {
          margin-bottom: 0;
        }

        .course__description-preview :global(*:first-child) {
          margin-top: 0;
        }

        .course__description-preview :global(p:last-child) {
          margin-bottom: 0;
        }

        .course__teacher--compact {
          margin-top: 0;
          padding-bottom: 0;
        }
      `}</style>
    </>
  );
};

export default PaginationList;
